import React from 'react';
import { SimpleGrid, Box } from '@chakra-ui/react';
import { colors } from '../../utils/colors';

interface BenefitTypeOption {
  value: string;
  label: string;
}

interface BenefitTypeSelectorProps {
  value?: string;
  onChange: (value: string) => void;
  options: BenefitTypeOption[];
}

const BenefitTypeSelector: React.FC<BenefitTypeSelectorProps> = ({
  value,
  onChange,
  options,
}) => (
  <SimpleGrid columns={options.length} spacing={3}>
    {options.map(option => {
      const isActive = option.value === value;
      return (
        <Box
          as={'button'}
          type={'button'}
          key={option.value}
          onClick={() => onChange(option.value)}
          borderRadius={10}
          py={4}
          px={2}
          textAlign={'center'}
          fontSize={14}
          fontWeight={isActive ? 700 : 600}
          bg={isActive ? colors.accent.main : 'rgba(255,255,255,0.04)'}
          color={isActive ? '#141414' : 'rgba(255,255,255,0.35)'}
          border={isActive ? 'none' : '1px solid rgba(255,255,255,0.08)'}
          transition={'background 0.15s ease, color 0.15s ease'}
          _hover={{
            bg: isActive ? colors.accent.main : 'rgba(255,255,255,0.08)',
          }}>
          {option.label}
        </Box>
      );
    })}
  </SimpleGrid>
);

export default BenefitTypeSelector;
